module.exports = __webpack_public_path__ + "img/card_tel.b225a13a.png";